<template>
    <v-expansion-panels accordion flat>
        <v-expansion-panel>
            <v-expansion-panel-header v-slot="{open}" class="pa-0">
                <v-row>
                    <v-col>
                        <v-row no-gutters>
                            <v-col class="v-label theme--light mb-2">
                                <label :class="{'primary--text' : open}">{{label}}</label>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="fill-width">
                            <v-col class="d-flex">
                                <div v-if="!href && !page" class="flex-grow-1">{{$translate('No link')}}</div>
                                <div v-if="pageObject" class="flex-grow-1">{{$translate('Page')}} <span class="text--secondary">{{pageObject.name}} ({{pageObject.path}}{{anchor ? ('#' + anchor) : ''}})</span></div>
                                <div v-else-if="href" class="text-truncate flex-grow-1">{{$translate('External page')}}: <span class="text--secondary">{{href}}</span></div>
                                <v-btn small icon v-if="open && clearable" @click.prevent="clear()"><v-icon >mdi-close</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <div v-if="hint" v-text="hint" />
                <v-radio-group v-model="internal">
                    <v-radio :label="$translate('Internal page')" :value="true" />
                    <v-radio :label="$translate('External page')" :value="false" />

                    <template v-if="internal">
                        <v-autocomplete :label="$translate('Page')" :items="sortedRoutes" :item-text="(x) => `${x.name} (${x.path})`" item-value="path" v-model="page" />
                        <v-text-field :label="$translate('Anchor name')" v-model="anchor" />
                    </template>
                    <template v-else>
                        <v-text-field :label="$translate('URL')" v-model="href" />
                        <v-checkbox :label="$translate('Open in new tab')" v-model="newTab" color="zoezi-edit-color" />
                    </template>
                </v-radio-group>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: 'LinkSetting',

    props: ['value', 'label', 'clearable', 'hint'],

    data: () => ({
        internal: true,
        href: null,
        page: null,
        newTab: false,
        anchor: null
    }),

    watch: {
        value: {
            immediate: true,
            handler(value) {
                if (value?.page) {
                    this.page = value.page;
                    this.anchor = value.anchor;
                    this.href = null;
                    this.internal = true;
                } else if (value?.href !== undefined) {
                    this.internal = false;
                    this.page = null;
                    this.href = value.href;
                    this.newTab = value.newTab;
                    this.anchor = null;
                } else {
                    this.internal = true;
                    this.page = this.clearable ? null : '/';
                    this.href = null;
                    this.anchor = null;
                }
            }
        },
        internal() {
            if (this.internal) {
                this.page = this.clearable ? null : '/';
                this.href = null;
                this.anchor = null;
            } else {
                this.page = null;
                this.href = null;
                this.anchor = null;
            }
        },
        emitValue() {
            this.$emit('input', this.emitValue);
        }
    },

    computed: {
        emitValue() {
            if (!this.page && !this.href) {
                return null;
            }

            if (this.internal) {
                return {page: this.page, anchor: this.anchor};
            } else {
                return {href: this.href, newTab: this.newTab};
            }
        },
        sortedRoutes() {
            return this.$root.siteconfig.routes.map(r => r.props).sort((a, b) => a.name.localeCompare(b.name));
        },
        pageObject() {
            return this.sortedRoutes.find(x => x.path == this.page);
        }
    },
    methods: {
        clear() {
            this.href = null;
            this.anchor = null;
            this.page = null;
        }
    }
}
</script>
